import { useApi } from "@lending/lib/api";

/**
 * Starts a Loan Portal verified identity challenge from a date of birth and tax
 * ID last four.
 *
 * The response either reports that a code was already sent (exactly one primary
 * applicant email matched) or returns masked email options for the user to
 * choose between. Full email addresses are never returned; each option carries
 * an opaque server-issued token instead.
 */
function useStartVerifiedIdentityChallengeMutation() {
  const $api = useApi();

  return $api.useMutation("post", "/v2/lending/verified_identity_challenges/");
}

export { useStartVerifiedIdentityChallengeMutation };
